<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title" v-text="currentText"></div>
            <div class="content">
                <IndexMain v-on:onIndexChanged="onIndexChanged" v-if="index == 1"></IndexMain>
                <WhitePollutionPrevent v-on:onIndexChanged="onIndexChanged" v-if="index == 2"></WhitePollutionPrevent>
                <WhitePollutionAdvice v-on:onIndexChanged="onIndexChanged" v-if="index == 3"></WhitePollutionAdvice>
                <LimitPlasticTextView v-on:onIndexChanged="onIndexChanged" v-if="index == 4"></LimitPlasticTextView>
            </div>
        </div>

    </div>
</template>

<script>
    import IndexMain from './IndexMain'
    import WhitePollutionPrevent from "./WhitePollutionPreventView";
    import WhitePollutionAdvice from "./WhitePollutionAdviceView";
    import LimitPlasticTextView from "./LimitPlasticTextView";
    export default {
        name: "PreventAndDoIndex",
        components: {IndexMain, WhitePollutionPrevent, WhitePollutionAdvice, LimitPlasticTextView},
        data() {
            return {
                index: 1,
                contentArray: ["", "白色污染的防治与对策", "白色污染的防治", "白色污染的对策", "限塑令"]
            }
        },
        computed: {
            currentText() {
                return this.contentArray[this.index];
            }
        },
        methods: {
            onIndexChanged(retIndex) {
                this.index = retIndex
            }
        }
    }
</script>

<style lang="scss" scoped>
    .right-content {
        margin-left: 130px;
        height: 100%;
        background: url("../../../assets/images/hai3.jpg") no-repeat;
        background-size: cover;
        .right-content-body {
            padding: 30px;
            max-height: 590px;
            overflow-y: auto;
            overflow-x: hidden;
        }
        .title {
            -webkit-text-stroke: 0.05em #33c;
            -webkit-text-fill-color : transparent;
            font-size: 30px;
            text-shadow: 3px 3px 2px #979cf8;
            text-align: left;
            font-family: SimSun;
        }
    }
</style>